import OKX from '../images/okxIcon.svg'
import UNISAT from '../images/unisatIcon.svg'
import UNIELON from '../images/unielonIcon.png'

export const wallets = [
    {
      name: 'OKX Wallet',
      alias: 'OKX',
      icon: OKX,
      chain: 'BTC'
    },
    {
      name: 'Unisat',
      alias: 'Unisat',
      icon: UNISAT,
      chain: 'BTC'
    },
    {
      name: 'Unielon Wallet',
      alias: 'Unielon',
      icon: UNIELON,
      chain: 'DOGE'
    },
  ]
